import { ActionIcon } from 'ui';
import { IconMinus, IconPlus } from 'ui/Icons';

type ZoomControlButtonProps = {
  onChange: (increment: boolean) => void;
};

const ZoomControlGroupButton = ({ onChange }: ZoomControlButtonProps) => {
  return (
    <ActionIcon.Group orientation="vertical">
      <ActionIcon variant="white" color="gray" onClick={() => onChange(true)}>
        <IconPlus />
      </ActionIcon>
      <ActionIcon variant="white" color="gray" onClick={() => onChange(false)}>
        <IconMinus />
      </ActionIcon>
    </ActionIcon.Group>
  );
};

export { ZoomControlGroupButton };
